module.exports = __webpack_public_path__ + "abd1ac7f3de02d04cfe7df798d30c925.svg";